'use client';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import ProvideServies from '@/components/technologies/provide-services';
import TechnologyFaq from '@/components/technologies/technology-faq';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import VueJsFAQ from '@/components/faqs/vuejs-faq';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />

            <TechHero
                className=""
                desc="Build highly innovative, futuristic, and intuitive business solutions with our custom Vue.js development services. Using our strategic technical acumen and the power of the Vue.js framework, we build robust and engaging web applications."
                alt="hero image"
                title="hero image"
                width={1089}
                height={604}
                path={'vuejs-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Vue.js <div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Vue.js" />
            <ContetVideoSection title="Vue.js Application Development Services for Every Business Industry">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Vue.js is a progressive JavaScript framework for building high-performing user interfaces and user-centric
                        single-page applications (SPAs). Vue.js is an open-source framework with its core library focused on the
                        view layer. By leveraging Vue.js, we can create modern single-page web apps as well as mobile
                        applications.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb is a top Vue.js development company with a dynamic presence in India, UK & USA. We feature vast
                        experience in developing a bespoke Vue.js app development. Our programmers are well-versed in using all
                        the tools and technologies related to Vue.js such as Mixins, Composable Function, Watchers, Single-File
                        Components, Vue Router, Vuex, Options API & Composition API, Vuelidate, and TypeScript.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        With in-depth expertise in building Vue.js applications, our team of Vue.js developers is all set to
                        assist you from the initial planning stage to deployment and support. Moreover, we sign an NDA to secure
                        your idea and offer post-launch support to ensure the app&apos;s and website&apos;s seamless functioning.
                        So, let us discuss your business idea for the ultimate result.
                    </p>
                </>
            </ContetVideoSection>
            <ProvideServies />
            <HireProcess
                bg="bg-vuejs"
                pageTitle="Hire Vue.js Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Vue.js."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Vue.js Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Vue.js Developers"
                desc="Select from different engagement models to hire Vue.js Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Vue.js Development Services" bg="bg-vuejs">
                <VueJsFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
